class PaylocityPayrollDetails {
  constructor($rootScope, $state, $http, $scope, AuthenticationService) {
    "ngInject";
    this.state = $state;
    this.$http = $http;
    this.$rootScope = $rootScope;
    this.auth = AuthenticationService;

    let self = this;

    self.currencyFormatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2
    });

    self.numberFormatter = new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 4
    });

    self.runTimestamp = new Date();
    self.payrollData = [];

    function loadForCheckDate(checkDate) {
      if (!checkDate) {
        self.state.go('paylocity-payroll');
        return;
      }
      self.payrollCheckDate = checkDate;
      self.loadPayroll();
      self.loadMetadata();
    }

    loadForCheckDate(self.state.params.checkDate);

    $scope.$on('$stateChangeSuccess', function (event, toState, toParams) {
      if (toState.name !== 'paylocity-payroll-details') {
        return;
      }
      var d = toParams.checkDate;
      if (!d) {
        return;
      }
      if (self.payrollCheckDate === d) {
        return;
      }
      loadForCheckDate(d);
    });
  }

  loadPayroll() {
    let self = this;
    self.payrollData = [];
    self.payrollRun = null;
    self.$http.get(self.$rootScope.apiHost + "/api/integrations/paylocity/payroll/" + this.payrollCheckDate, {withCredentials: true}).then(function (success) {
      var data = success.data;
      if (data && !Array.isArray(data)) {
        self.payrollRun = data;
      }
      self.payrollData = self.normalizePayrollData(data);
    });
  }

  normalizePayrollData(data) {
    let self = this;
    if (!data) {
      return [];
    }
    if (Array.isArray(data)) {
      return data.map(function (check) {
        return self.normalizePaycheckEntry(check);
      });
    }

    var entries = data.paychecks || data.content || data.payrollEntries || data.employees;
    if (!Array.isArray(entries)) {
      return [];
    }

    return entries.map(function (check) {
      return self.normalizePaycheckEntry(check);
    });
  }

  normalizePaycheckDetail(detail) {
    if (!detail) {
      return detail;
    }
    return Object.assign({}, detail, {
      detail: detail.detail != null ? detail.detail : detail.det,
      detailCode: detail.detailCode != null ? detail.detailCode : detail.detCode,
      detailType: detail.detailType != null ? detail.detailType : detail.detType
    });
  }

  normalizePaycheckEntry(check) {
    var self = this;
    var user = check.user || {};
    var paycheckDetail = (check.paycheckDetail || []).map(function (detail) {
      return self.normalizePaycheckDetail(detail);
    });
    return Object.assign({}, check, {
      firstName: check.firstName || user.firstName,
      lastName: check.lastName || user.lastName,
      paycheckDetail: paycheckDetail
    });
  }

  getPayrollEntries() {
    return Array.isArray(this.payrollData) ? this.payrollData : [];
  }

  loadMetadata() {
    let self = this;
    self.$http.get(self.$rootScope.apiHost + "/api/integrations/paylocity/status", {withCredentials: true}).then(function (success) {
      self.paylocityIntegration = success.data || {};
    });
  }

  formatCurrency(value) {
    if (value === null || value === undefined || value === '') {
      return '';
    }
    return this.currencyFormatter.format(value);
  }

  formatAmount(value) {
    if (value === null || value === undefined || value === '') {
      return '';
    }
    return this.numberFormatter.format(value);
  }

  formatHours(value) {
    if (value === null || value === undefined || value === '') {
      return '';
    }
    return this.numberFormatter.format(value);
  }

  formatShortDate(date) {
    if (!date) {
      return '';
    }
    var d = new Date(date);
    if (isNaN(d.getTime())) {
      return date;
    }
    return (d.getMonth() + 1) + '/' + d.getDate() + '/' + d.getFullYear();
  }

  formatLongDate(date) {
    if (!date) {
      return '';
    }
    var d = new Date(date);
    if (isNaN(d.getTime())) {
      return date;
    }
    var months = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
    var day = d.getDate() < 10 ? '0' + d.getDate() : '' + d.getDate();
    return months[d.getMonth()] + '/' + day + '/' + d.getFullYear();
  }

  getCompanyLabel() {
    var integration = this.paylocityIntegration || {};
    var companyName = integration.companyName || integration.organizationName;
    var companyId = integration.paylocityCompanyId;
    if (companyName && companyId) {
      return companyName + ' (' + companyId + ')';
    }
    if (companyName) {
      return companyName;
    }
    if (companyId) {
      return '(' + companyId + ')';
    }
    return '';
  }

  getPayPeriodLabel() {
    var run = this.payrollRun || {};
    if (run.payPeriodStart && run.payPeriodEnd) {
      return this.formatLongDate(run.payPeriodStart) + ' through ' + this.formatLongDate(run.payPeriodEnd);
    }
    return '';
  }

  getEarnings(paycheckDetail) {
    if (!paycheckDetail) {
      return [];
    }
    return paycheckDetail.filter(function (detail) {
      return detail.detail === 'E';
    });
  }

  getTaxes(paycheckDetail) {
    if (!paycheckDetail) {
      return [];
    }
    return paycheckDetail.filter(function (detail) {
      return detail.detail === 'T'
        && !detail.detailCode.endsWith('-R')
        && detail.amount > 0
        && detail.detailCode !== 'FUTA'
        && detail.detailType !== 'SUI'
        && !detail.employerResponsible;
    });
  }

  getDeductions(paycheckDetail) {
    if (!paycheckDetail) {
      return [];
    }
    return paycheckDetail.filter(function (detail) {
      return detail.detail === 'D';
    });
  }

  getEmployeeId(entry) {
    var user = entry.user || {};
    return entry.employeeId || entry.paylocityEmployeeId || entry.empId || user.id || entry.id || '—';
  }

  getBadge(entry) {
    return entry.badge || entry.badgeNumber || 'Not Listed';
  }

  getSalary(entry) {
    if (entry.salary != null && entry.salary !== '') {
      return this.formatAmount(entry.salary);
    }
    var user = entry.user || {};
    if (user.annualSalary != null && user.annualSalary > 0) {
      return this.formatAmount(user.annualSalary);
    }
    if (entry.regularDollars != null && entry.regularDollars !== '' && !entry.regularHours) {
      return this.formatAmount(entry.regularDollars);
    }
    var reg = this.getRegEarning(entry);
    if (reg && reg.detailCode === 'REG' && reg.amount && !reg.hours) {
      return this.formatAmount(reg.amount);
    }
    return null;
  }

  getRate(entry) {
    if (entry.rate != null && entry.rate !== '') {
      return this.formatAmount(entry.rate);
    }
    var reg = this.getRegEarning(entry);
    if (reg && reg.rate != null) {
      return this.formatAmount(reg.rate);
    }
    return '—';
  }

  getFrequency(entry) {
    return entry.payFrequency || entry.frequency || entry.taxFrequency || '(S) Semi-Monthly';
  }

  getRegEarning(entry) {
    var earnings = this.getEarnings(entry.paycheckDetail);
    for (var i = 0; i < earnings.length; i++) {
      if (earnings[i].detailCode === 'REG') {
        return earnings[i];
      }
    }
    return earnings.length ? earnings[0] : null;
  }

  getEarningLabel(earning) {
    return earning.detailType || earning.detailCode;
  }

  getTaxLabel(tax) {
    return tax.detailType || tax.detailCode;
  }

  getDeductionLabel(deduction) {
    return deduction.detailType || deduction.detailCode;
  }

  getTaxStatus(tax) {
    return tax.taxStatus || tax.status || '';
  }

  getTaxableAmount(tax) {
    if (tax.taxable != null && tax.taxable !== '') {
      return this.formatAmount(tax.taxable);
    }
    if (tax.hours != null && tax.hours !== '') {
      return this.formatAmount(tax.hours);
    }
    return '';
  }

  getCheckType(entry) {
    return entry.checkType || entry.type || 'Regular';
  }

  getDirectDeposit(entry) {
    if (entry.directDeposit != null) {
      return this.formatCurrency(entry.directDeposit);
    }
    return this.formatCurrency(entry.netPay);
  }

  getCheckAmount(entry) {
    if (entry.checkAmount != null) {
      return this.formatCurrency(entry.checkAmount);
    }
    if (entry.check != null) {
      return this.formatCurrency(entry.check);
    }
    return this.formatCurrency(0);
  }

  getTotalEarningsHours(paycheckDetail) {
    var total = 0;
    this.getEarnings(paycheckDetail).forEach(function (earning) {
      if (!earning.detailCode.endsWith('ER') && earning.hours) {
        total += earning.hours;
      }
    });
    return this.formatHours(total);
  }

  getTotalEarningsForEmployee(paycheckDetail) {
    var total = 0;
    this.getEarnings(paycheckDetail).forEach(function (earning) {
      if (!earning.detailCode.endsWith('ER')) {
        total += earning.amount;
      }
    });
    return this.formatCurrency(total);
  }

  getTotalWitholdingsForEmployee(paycheckDetail) {
    var total = 0;
    this.getTaxes(paycheckDetail).forEach(function (tax) {
      total += tax.amount;
    });
    return this.formatCurrency(total);
  }

  getTotalDeductionsForEmployee(paycheckDetail) {
    var total = 0;
    this.getDeductions(paycheckDetail).forEach(function (deduction) {
      total += deduction.amount;
    });
    return this.formatCurrency(total);
  }

  hasNegativeNetChecks() {
    return this.getPayrollEntries().some(function (entry) {
      return entry.netPay < 0;
    });
  }

  getEmployeeCount() {
    return this.getPayrollEntries().length;
  }

  getRunUserLabel() {
    var user = this.auth && this.auth.user;
    if (!user) {
      return '';
    }
    return (user.username || user.email || (user.firstName + ' ' + user.lastName)).trim();
  }

  getRunTimestampLabel() {
    var d = this.runTimestamp;
    var hours = d.getHours();
    var minutes = d.getMinutes();
    var ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    if (hours === 0) {
      hours = 12;
    }
    var minuteLabel = minutes < 10 ? '0' + minutes : '' + minutes;
    return 'Run on ' + this.formatShortDate(d) + ' at ' + hours + ':' + minuteLabel + ' ' + ampm;
  }

  getEmployeeGender(entry) {
    var user = entry.user || {};
    return entry.gender || entry.sex || user.gender || user.sex || '';
  }

  isFemaleEmployee(entry) {
    var gender = String(this.getEmployeeGender(entry)).trim().toLowerCase();
    return gender === 'f' || gender === 'female' || gender === 'fem';
  }

  isMaleEmployee(entry) {
    var gender = String(this.getEmployeeGender(entry)).trim().toLowerCase();
    return gender === 'm' || gender === 'male';
  }

  getReportFemaleCount() {
    return this.getPayrollEntries().filter(this.isFemaleEmployee.bind(this)).length;
  }

  getReportMaleCount() {
    return this.getPayrollEntries().filter(this.isMaleEmployee.bind(this)).length;
  }

  getReportEmployeeCount() {
    var run = this.payrollRun || {};
    if (run.employeesPaid != null && run.employeesPaid !== '') {
      return run.employeesPaid;
    }
    return this.getPayrollEntries().length;
  }

  _aggregateByDetailCode(entries, lineFilter) {
    var totals = {};
    var self = this;

    entries.forEach(function (entry) {
      lineFilter(entry.paycheckDetail).forEach(function (line) {
        var code = line.detailCode;
        if (!code) {
          return;
        }
        if (!totals[code]) {
          totals[code] = {
            code: code,
            hours: 0,
            amount: 0,
            taxable: 0
          };
        }
        if (line.hours != null && line.hours !== '' && !code.endsWith('ER')) {
          totals[code].hours += Number(line.hours) || 0;
        }
        totals[code].amount += Number(line.amount) || 0;
        if (line.taxable != null && line.taxable !== '') {
          totals[code].taxable += Number(line.taxable) || 0;
        } else if (line.hours != null && line.hours !== '' && line.detail === 'T') {
          totals[code].taxable += Number(line.hours) || 0;
        }
      });
    });

    return Object.keys(totals).sort().map(function (code) {
      return totals[code];
    });
  }

  getReportTotalsEarnings() {
    var self = this;
    return this._aggregateByDetailCode(this.getPayrollEntries(), function (paycheckDetail) {
      return self.getEarnings(paycheckDetail);
    });
  }

  getReportTotalsTaxes() {
    var self = this;
    return this._aggregateByDetailCode(this.getPayrollEntries(), function (paycheckDetail) {
      return self.getTaxes(paycheckDetail);
    });
  }

  getReportTotalsDeductions() {
    var self = this;
    return this._aggregateByDetailCode(this.getPayrollEntries(), function (paycheckDetail) {
      return self.getDeductions(paycheckDetail);
    });
  }

  _sumReportEarningsHours() {
    var total = 0;
    this.getReportTotalsEarnings().forEach(function (row) {
      if (!row.code.endsWith('ER')) {
        total += row.hours;
      }
    });
    return total;
  }

  _sumReportEarningsAmount() {
    var total = 0;
    this.getReportTotalsEarnings().forEach(function (row) {
      if (!row.code.endsWith('ER')) {
        total += row.amount;
      }
    });
    return total;
  }

  _sumReportTaxAmount() {
    var total = 0;
    this.getReportTotalsTaxes().forEach(function (row) {
      total += row.amount;
    });
    return total;
  }

  _sumReportDeductionAmount() {
    var total = 0;
    this.getReportTotalsDeductions().forEach(function (row) {
      total += row.amount;
    });
    return total;
  }

  getReportTotalEarningsHours() {
    return this.formatHours(this._sumReportEarningsHours());
  }

  getReportTotalEarningsAmount() {
    return this.formatCurrency(this._sumReportEarningsAmount());
  }

  getReportTotalTaxAmount() {
    return this.formatCurrency(this._sumReportTaxAmount());
  }

  getReportTotalDeductionAmount() {
    return this.formatCurrency(this._sumReportDeductionAmount());
  }

  _getEntryCheckAmount(entry) {
    if (entry.checkAmount != null) {
      return Number(entry.checkAmount) || 0;
    }
    if (entry.check != null) {
      return Number(entry.check) || 0;
    }
    return 0;
  }

  _getEntryDirectDepositAmount(entry) {
    if (entry.directDeposit != null) {
      return Number(entry.directDeposit) || 0;
    }
    return Number(entry.netPay) || 0;
  }

  _isVoucherEntry(entry) {
    var checkType = String(entry.checkType || entry.type || '').toLowerCase();
    if (checkType.indexOf('voucher') >= 0) {
      return true;
    }
    return this._getEntryCheckAmount(entry) <= 0;
  }

  getReportCheckVoucherCount() {
    return this.getPayrollEntries().length;
  }

  getReportCheckCount() {
    return this.getPayrollEntries().filter(function (entry) {
      return !this._isVoucherEntry(entry);
    }.bind(this)).length;
  }

  getReportVoucherCount() {
    return this.getPayrollEntries().filter(function (entry) {
      return this._isVoucherEntry(entry);
    }.bind(this)).length;
  }

  getReportTotalNet() {
    var run = this.payrollRun || {};
    if (run.totalNet != null && run.totalNet !== '') {
      return this.formatCurrency(run.totalNet);
    }
    var total = 0;
    this.getPayrollEntries().forEach(function (entry) {
      total += Number(entry.netPay) || 0;
    });
    return this.formatCurrency(total);
  }

  getReportTotalDirectDeposit() {
    var total = 0;
    this.getPayrollEntries().forEach(function (entry) {
      total += this._getEntryDirectDepositAmount(entry);
    }.bind(this));
    return this.formatCurrency(total);
  }

  getReportTotalCheckAmount() {
    var total = 0;
    this.getPayrollEntries().forEach(function (entry) {
      total += this._getEntryCheckAmount(entry);
    }.bind(this));
    return this.formatCurrency(total);
  }

  hasReportTotals() {
    return this.getPayrollEntries().length > 0;
  }

}

export default PaylocityPayrollDetails;



// WEBPACK FOOTER //
// ./client/pages/admin/integrations/paylocity/capabilities/payroll/paylocity-payroll-details.controller.js